import React, { useEffect, useRef } from 'react'
import {AiOutlineCopyrightCircle} from 'react-icons/ai'
import { Link } from 'react-router-dom'
const Footer = () => {
    const footerRef = useRef(null);
    useEffect(() => {
        const footerElement = footerRef.current;
        if (!footerElement) return;
        const update = () => {
            document.documentElement.style.setProperty('--footer-height', `${footerElement.offsetHeight}px`);
        };
        update();
        const observer = new ResizeObserver(update);
        observer.observe(footerElement);
        return () => observer.disconnect();
    }, []);
    return (
        // 20px: the page area keeps an 8px gap above the footer, so footer + gap = 28px, the old footer's height.
        <div ref={footerRef} className="fixed bottom-0 left-0 z-[60] w-full h-5 flex items-center justify-between py-0 px-5 text-[11px] leading-none text-slate-300 primary-bg-color">
            <div className='mx-12'>Version <span className='font-bold'>{process.env.REACT_APP_VERSION}</span></div>
            <div className='flex justify-center items-center gap-1 '> 
                <span>ALL CopyRight </span> 
                <AiOutlineCopyrightCircle/>
                <span> <span><Link target='_blank' to={`https://4sharks.org`}>4SHARKS</Link> </span>FOR SOFTWARE SOLUTIONS</span>
            </div>
        </div>
    )
}

export default Footer

